"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarPlus, faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { Period } from "@/helpers/Types";
import DecisionPointDropdown from "./DecisionPointDropdown";
import { calculateDecisionTimes, formatDate } from "../services/waveDecisionService";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
interface SubsequentDecisionsProps {
  readonly firstDecisionTime: number;
  readonly subsequentDecisions: number[]; // array of intervals in milliseconds
  readonly setSubsequentDecisions: (decisions: number[]) => void;
}
export default function SubsequentDecisions(t0) {
  const $ = _c(65);
  const {
    firstDecisionTime,
    subsequentDecisions,
    setSubsequentDecisions
  } = t0;
  const [additionalTime, setAdditionalTime] = useState(1);
  const [timeframeUnit, setTimeframeUnit] = useState(Period.DAYS);
  let t1;
  let t2;
  if ($[0] !== timeframeUnit) {
    t1 = () => {
      if (timeframeUnit === Period.MINUTES) {
        setTimeframeUnit(Period.HOURS);
      }
    };
    t2 = [timeframeUnit];
    $[0] = timeframeUnit;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const periodToMs = _temp;
  let t3;
  if ($[3] !== additionalTime || $[4] !== setSubsequentDecisions || $[5] !== subsequentDecisions || $[6] !== timeframeUnit) {
    t3 = () => {
      if (additionalTime <= 0) {
        return;
      }
      const intervalMs = periodToMs(additionalTime, timeframeUnit);
      setSubsequentDecisions([...subsequentDecisions, intervalMs]);
      setAdditionalTime(1);
    };
    $[3] = additionalTime;
    $[4] = setSubsequentDecisions;
    $[5] = subsequentDecisions;
    $[6] = timeframeUnit;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleAddTimeframe = t3;
  let t4;
  if ($[8] !== setSubsequentDecisions || $[9] !== subsequentDecisions) {
    t4 = (index, e) => {
      e.stopPropagation();
      const newDecisions = [...subsequentDecisions];
      newDecisions.splice(index, 1);
      setSubsequentDecisions(newDecisions);
    };
    $[8] = setSubsequentDecisions;
    $[9] = subsequentDecisions;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleDeleteDecision = t4;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[11] !== additionalTime || $[12] !== firstDecisionTime || $[13] !== handleAddTimeframe || $[14] !== handleDeleteDecision || $[15] !== subsequentDecisions || $[16] !== timeframeUnit) {
    const decisionDates = calculateDecisionTimes(firstDecisionTime, subsequentDecisions);
    t9 = "tw-bg-iron-900 tw-mt-5";
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <div className="tw-flex tw-items-center tw-justify-between"><h3 className="tw-text-iron-50 tw-text-lg tw-font-semibold tw-mb-2">Additional Announcements</h3></div>;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <div className="tw-border-b tw-border-iron-700/30 tw-pb-3 tw-mb-2"><p className="tw-text-xs tw-text-iron-300 tw-mb-0"><span className="tw-text-primary-400 tw-font-medium">Timeline:</span>{" "}Define when winners will be selected throughout your wave.</p></div>;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    let t13;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <div className="tw-absolute tw-left-[-14px] tw-top-3 tw-w-6 tw-h-6 tw-rounded-full tw-bg-primary-500 tw-flex tw-items-center tw-justify-center tw-text-black tw-font-semibold tw-text-xs tw-ring-4 tw-ring-iron-800">1</div>;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <div className="tw-text-xs tw-text-primary-300 tw-font-medium tw-mb-0.5">First Winners Announcement</div>;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== firstDecisionTime) {
      t15 = formatDate(firstDecisionTime);
      $[29] = firstDecisionTime;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    let t16;
    if ($[31] !== firstDecisionTime) {
      t16 = new Date(firstDecisionTime).toLocaleDateString(undefined, {
        weekday: "long"
      });
      $[31] = firstDecisionTime;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    let t17;
    if ($[33] !== t16) {
      t17 = <span className="tw-text-xs tw-text-iron-400 tw-ml-1">({t16})</span>;
      $[33] = t16;
      $[34] = t17;
    } else {
      t17 = $[34];
    }
    let t18;
    if ($[35] !== t15 || $[36] !== t17) {
      t18 = <div className="tw-relative tw-mb-6">{t13}<div className="tw-bg-iron-700/40 tw-px-4 tw-py-3 tw-rounded-lg tw-shadow-md tw-border-l-4 tw-border-primary-500">{t14}<p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50 tw-flex tw-items-center">{t15}{t17}</p></div></div>;
      $[35] = t15;
      $[36] = t17;
      $[37] = t18;
    } else {
      t18 = $[37];
    }
    t12 = <div className="tw-relative tw-pl-2 tw-ml-2 tw-mb-6">{t18}{subsequentDecisions.map((interval, index_0) => <div key={index_0} className="tw-relative tw-mb-6"><div className="tw-absolute tw-left-[-14px] tw-top-3 tw-w-6 tw-h-6 tw-rounded-full tw-bg-primary-400/80 tw-flex tw-items-center tw-justify-center tw-text-black tw-font-semibold tw-text-xs tw-ring-4 tw-ring-iron-800">{index_0 + 2}</div><div className="tw-absolute tw-left-[-22px] tw-top-[-8px] tw-flex tw-items-center tw-justify-center"><span className="tw-px-1.5 tw-py-0.5 tw-bg-iron-900 tw-border tw-border-iron-700/70 tw-rounded tw-text-xs tw-text-primary-300 tw-font-medium tw-whitespace-nowrap">+{interval >= periodToMs(1, Period.WEEKS) ? `${Math.round(interval / periodToMs(1, Period.WEEKS))}w` : interval >= periodToMs(1, Period.DAYS) ? `${Math.round(interval / periodToMs(1, Period.DAYS))}d` : `${Math.round(interval / periodToMs(1, Period.HOURS))}h`}</span></div><div className="tw-group tw-bg-[#24242B] tw-px-4 tw-py-3 tw-rounded-lg tw-shadow-sm tw-border-l-4 tw-border-primary-400/70 tw-transition-all tw-duration-200 hover:tw-shadow-md"><div className="tw-flex tw-justify-between tw-items-start"><div><div className="tw-text-xs tw-text-primary-300/90 tw-font-medium tw-mb-0.5">Winners Announcement #{index_0 + 2}</div><p className="tw-mb-0 tw-text-sm tw-font-medium tw-text-iron-50 tw-flex tw-items-center">{formatDate(decisionDates[index_0 + 1])}<span className="tw-text-xs tw-text-iron-400 tw-ml-1">({new Date(decisionDates[index_0 + 1]).toLocaleDateString(undefined, {
                    weekday: "long"
                  })})</span></p></div><button onClick={e_0 => handleDeleteDecision(index_0, e_0)} className="tw-opacity-0 tw-border-0 group-hover:tw-opacity-100 tw-transition-all tw-duration-300 tw-bg-iron-700/30 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-size-7 hover:tw-bg-iron-700/60 desktop-hover:hover:tw-text-red"><FontAwesomeIcon icon={faTrashCan} className="tw-size-3.5" /></button></div></div></div>)}</div>;
    t5 = "tw-mt-6 tw-bg-iron-800/60 tw-rounded-lg tw-p-4";
    if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="tw-flex tw-items-center tw-mb-3"><div className="tw-flex tw-items-center tw-justify-center tw-w-8 tw-h-8 tw-rounded-full tw-bg-primary-500/20 tw-text-primary-400 tw-text-xs tw-font-medium tw-mr-3"><FontAwesomeIcon icon={faCalendarPlus} className="tw-size-4 tw-flex-shrink-0" /></div><div><p className="tw-mb-0 tw-text-base tw-font-medium tw-text-iron-50">Schedule Next Winners Announcement</p><p className="tw-text-xs tw-text-iron-400 tw-mb-0">Set time between announcements</p></div></div>;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    let t19;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = e_1 => setAdditionalTime(e_1.target.value === "" ? 0 : parseInt(e_1.target.value, 10));
      $[39] = t19;
    } else {
      t19 = $[39];
    }
    let t20;
    if ($[40] !== additionalTime) {
      t20 = <div className="tw-w-24 tw-bg-iron-900 tw-rounded-l-lg tw-ring-1 tw-ring-iron-700 tw-ring-inset focus-within:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out"><input type="number" min="1" value={additionalTime} onChange={t19} className="tw-w-full tw-h-full tw-px-4 tw-py-4 tw-bg-transparent tw-border-0 tw-text-primary-400 tw-font-medium tw-caret-primary-300 focus:tw-outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:tw-appearance-none [&::-webkit-inner-spin-button]:tw-appearance-none" aria-label="Time value" /></div>;
      $[40] = additionalTime;
      $[41] = t20;
    } else {
      t20 = $[41];
    }
    let t21;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = value => setTimeframeUnit(value);
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    let t22;
    if ($[43] !== timeframeUnit) {
      t22 = <DecisionPointDropdown value={timeframeUnit} onChange={t21} />;
      $[43] = timeframeUnit;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    let t23;
    if ($[45] !== t20 || $[46] !== t22) {
      t23 = <div className="tw-flex tw-items-stretch tw-rounded-lg tw-flex-1 tw-w-full">{t20}{t22}</div>;
      $[45] = t20;
      $[46] = t22;
      $[47] = t23;
    } else {
      t23 = $[47];
    }
    const t24 = !additionalTime;
    let t25;
    if ($[48] !== handleAddTimeframe || $[49] !== t24) {
      t25 = <div className="tw-ml-3 tw-flex-shrink-0"><PrimaryButton onClicked={handleAddTimeframe} disabled={t24} loading={false} padding="tw-px-4 tw-py-2.5">Add to Timeline</PrimaryButton></div>;
      $[48] = handleAddTimeframe;
      $[49] = t24;
      $[50] = t25;
    } else {
      t25 = $[50];
    }
    if ($[51] !== t23 || $[52] !== t25) {
      t7 = <div className="tw-flex tw-items-center">{t23}{t25}</div>;
      $[51] = t23;
      $[52] = t25;
      $[53] = t7;
    } else {
      t7 = $[53];
    }
    t8 = additionalTime > 0 && <div className="tw-mt-4"><div className="tw-flex tw-items-center"><div className="tw-text-xs tw-text-iron-400"><span className="tw-text-primary-400/80">Preview:</span>{" "}{subsequentDecisions.length > 0 ? `Next announcement #${subsequentDecisions.length + 2} on` : "First additional announcement on"}<span className="tw-text-iron-300 tw-ml-1 tw-font-medium">{formatDate(subsequentDecisions.length > 0 ? new Date(decisionDates[decisionDates.length - 1]).getTime() + periodToMs(additionalTime, timeframeUnit) : new Date(firstDecisionTime).getTime() + periodToMs(additionalTime, timeframeUnit))}</span></div></div></div>;
    $[11] = additionalTime;
    $[12] = firstDecisionTime;
    $[13] = handleAddTimeframe;
    $[14] = handleDeleteDecision;
    $[15] = subsequentDecisions;
    $[16] = timeframeUnit;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t13;
  if ($[54] !== t5 || $[55] !== t6 || $[56] !== t7 || $[57] !== t8) {
    t13 = <div className={t5}>{t6}{t7}{t8}</div>;
    $[54] = t5;
    $[55] = t6;
    $[56] = t7;
    $[57] = t8;
    $[58] = t13;
  } else {
    t13 = $[58];
  }
  let t14;
  if ($[59] !== t10 || $[60] !== t11 || $[61] !== t12 || $[62] !== t13 || $[63] !== t9) {
    t14 = <div className={t9}>{t10}{t11}{t12}{t13}</div>;
    $[59] = t10;
    $[60] = t11;
    $[61] = t12;
    $[62] = t13;
    $[63] = t9;
    $[64] = t14;
  } else {
    t14 = $[64];
  }
  return t14;
}
function _temp(time, period) {
  switch (period) {
    case Period.MINUTES:
      {
        return time * 60000;
      }
    case Period.HOURS:
      {
        return time * 3600000;
      }
    case Period.DAYS:
      {
        return time * 86400000;
      }
    case Period.WEEKS:
      {
        return time * 604800000;
      }
    default:
      {
        return 0;
      }
  }
}